import { render, staticRenderFns } from "./language_selector.vue?vue&type=template&id=68c74127&scoped=true&"
import script from "./language_selector.vue?vue&type=script&lang=js&"
export * from "./language_selector.vue?vue&type=script&lang=js&"
import style0 from "./language_selector.vue?vue&type=style&index=0&id=68c74127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c74127",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VList,VListItem,VMenu})
